import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { Modal, Dropdown } from 'react-bootstrap'
import DatePicker from "react-datepicker"
import Select from 'react-select'
import { toast } from 'react-toastify'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import XLSX from 'xlsx-js-style';
import { styleExcelSheet } from 'helpers/excel'

import { SET_REPORT_SELECTED_CLIENT, SET_REPORT_CLIENT_FILTER } from 'store/report/actions';
import { PGET, GET, POST } from 'helpers/api'
import { formatMoney, regexPhoneNumber, formatDateBackend, returnSign, formatDate, findFromArrayById } from 'helpers/helpers'
import Pagination, { ItemPerPage } from "pages/parts/Pagination"

function Index() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const reduxAccount = useSelector(state => state.account)

	const paymentTypes = [{ 'id': 1, 'name': t('CASH') }, { 'id': 2, 'name': t('TERMINAL') }, { 'id': 3, 'name': t('MONEY_TRANSFER') }]
	const currencies = [{ "id": 1, "name": "So`m" }, { "id": 2, "name": "USD" }]
	const paymentPurposes = [{ "id": 4, "name": "Долг" }, { "id": 5, "name": "Погашение задолженности" }]
	const [totalAmount, setTotalAmont] = useState([])
	const [data, setData] = useState([])
	const [poses, setPoses] = useState([])
	const [modalPayment, setModalPayment] = useState(false)
	const [isDebt, setIsDebt] = useState(false)
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [ItemsPerPage, setItemsPerPage] = useState(20)
	const [URL, setURL] = useState("");
	const [pageCount, setPageCount] = useState(0)

	const [filterData, setFilterData] = useState({
		startDate: null,
		endDate: null,
		posId: reduxAccount.posId,
		paymentPurposeId: null,
		search: '',
		tableSortKey: '',
		tableSortDirection: ',asc',
	})
	const [pagination, setPagination] = useState({
		url: '/services/web/api/report-client-pageList',
		response: null
	})

	function redirectToInner(item) {
		dispatch(SET_REPORT_SELECTED_CLIENT(item))
		dispatch(SET_REPORT_CLIENT_FILTER({ posId: filterData.posId }))
		navigate('/report/clients-inner-debts')
	}

	function redirectToSelectOnSale(item) {
		dispatch(SET_REPORT_SELECTED_CLIENT(item))
		dispatch(SET_REPORT_CLIENT_FILTER({ posId: filterData.posId }))
		navigate('/report/clients-inner-cheques')
	}

	function selectItem(item) {
		var itemCopy = { ...item }
		itemCopy.posId = poses[0]['id']
		itemCopy.paymentTypeId = 1
		itemCopy.amountTypeId = 1
		itemCopy.currencyId = 1
		itemCopy.amountIn = ''
		setSelectedItem(itemCopy)
	}

	async function sendDebtSms() {
		if (!selectedItem?.clientId) {
			toast.warning(t('NO_CLIENT_SELECTED'))
			return
		}

		const posId = selectedItem.posId || poses[0]?.id
		if (!posId) {
			toast.warning(t('LIST_IS_EMPTY'))
			return
		}

		const response = await POST('/services/web/api/clients-send-debt-sms',
			{ clientId: selectedItem.clientId, posId }, { loader: true })

		if (response) {
			toast.success(t('DEBT_SMS_SENT'))
		}
	}

	async function payment(e) {
		e.preventDefault();

		var selectedItemCopy = { ...selectedItem }

		var sendData = {}
		sendData.amountIn = isDebt ? -Math.abs(selectedItemCopy.amountIn) : selectedItemCopy.amountIn
		sendData.currencyId = selectedItemCopy.currencyId
		sendData.clientId = selectedItemCopy.clientId
		sendData.paymentTypeId = selectedItemCopy.paymentTypeId
		sendData.posId = selectedItemCopy.posId
		sendData.note = selectedItemCopy.note

		var response = await POST('/services/web/api/clients-payment', sendData, { loader: true })

		if (response) {
			showPaymentModal(false)
			getData()
		}
	}

	async function showPaymentModal(bool, debt = false) {
		var paymentDataCopy = {}
		if (!bool) {
			paymentDataCopy.paymentTypeId = 1
			paymentDataCopy.amountTypeId = 1
			paymentDataCopy.currencyId = 1
			paymentDataCopy.amountIn = ''
			setSelectedItem(paymentDataCopy)
			setIsDebt(false)
		} else {
			if (!selectedItem?.clientId) {
				toast.warning(t('NO_CLIENT_SELECTED'))
				return
			}
			setIsDebt(debt)
		}

		setModalPayment(bool)
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getData() {
		const { tableSortKey: _sk, tableSortDirection: _sd, ...filterDataForAPI } = filterData
		const response = await PGET(`/services/web/api/report-client-pageList`, { ...filterDataForAPI, size: ItemsPerPage }
			, { loader: true })
		if (response) {
			setPagination({ ...pagination, 'url': "/services/web/api/report-client-pageList", 'response': response })
			setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))

			setData(response.data)
		}

		const temporaryTotalAmount = await GET(`/services/web/api/report-client-total`)
		setTotalAmont(temporaryTotalAmount)
	}

	async function getPoses() {
		const response = await GET('/services/web/api/pos-helper')
		if (response) {
			// response.unshift({ 'id': null, 'name': t('ALL') })
			setPoses(response)
		}
	}

	async function searchWithFilter(exportToExcel = false, tableSort = "") {
		var filterUrl = "/services/web/api/report-client-pageList"
		var urlParams = ""
		checkFilter()

		if (filterData.startDate)
			urlParams += returnSign(urlParams) + 'startDate=' + filterData.startDate
		if (filterData.endDate)
			urlParams += returnSign(urlParams) + 'endDate=' + filterData.endDate
		if (filterData.posId)
			urlParams += returnSign(urlParams) + 'posId=' + filterData.posId
		if (filterData.paymentPurposeId)
			urlParams += returnSign(urlParams) + 'paymentPurposeId=' + filterData.paymentPurposeId
		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search

		if ("/services/web/api/report-client-pageList" + urlParams !== filterUrl && !exportToExcel)
			setFilterDataExist(true)

		var filterUrlParams = urlParams
		var sortParam = ''
		if (tableSort) {
			var filterDataCopy = { ...filterData }
			if (filterDataCopy.tableSortKey === tableSort) {
				filterDataCopy.tableSortDirection = filterDataCopy.tableSortDirection === ',asc' ? ',desc' : ',asc'
			} else {
				filterDataCopy.tableSortDirection = ',asc'
			}
			filterDataCopy.tableSortKey = tableSort
			setFilterData(filterDataCopy)
			sortParam = 'sort=' + tableSort + filterDataCopy.tableSortDirection
		} else if (filterData.tableSortKey) {
			sortParam = 'sort=' + filterData.tableSortKey + filterData.tableSortDirection
		}
		if (sortParam) {
			urlParams += returnSign(urlParams) + sortParam
		}
		let WithoutParams = filterUrl
		filterUrl = filterUrl + urlParams
		setURL(filterUrl);

		if (exportToExcel) {
			filterUrl = "/services/web/api/report-client-excel" + urlParams
			const response = await GET(filterUrl)

			const borderStyle = {
				top: { style: "thin", color: { rgb: "000000" } },
				bottom: { style: "thin", color: { rgb: "000000" } },
				left: { style: "thin", color: { rgb: "000000" } },
				right: { style: "thin", color: { rgb: "000000" } }
			};

			// Define column widths
			const columnWidths = [
				{ wch: 4 },  // №
				{ wch: 15 }, // CLIENT
				{ wch: 13 }, // MOBILE
				{ wch: 13 }, // PHONE
				{ wch: 15 }, // NOTE
				{ wch: 10 }, // USD
				{ wch: 13 }  // Сум
			];

			// Define header styles
			const headerStyle = {
				font: { bold: true },
				border: borderStyle,
				alignment: { horizontal: "center", vertical: "center" }
			};

			// Define cell style
			const cellStyle = {
				font: { color: { rgb: "000000" } },
				border: borderStyle
			};

			const wrapTextStyle = {
				...cellStyle,
				alignment: { wrapText: true }
			};

			const excelHeaders = [
				[{ v: "№", s: headerStyle },
				{ v: t('CLIENT'), s: headerStyle },
				{ v: t('MOBILE'), s: headerStyle },
				{ v: t('PHONE'), s: headerStyle },
				{ v: t('NOTE'), s: headerStyle },
				{ v: 'USD', s: headerStyle },
				{ v: 'Сум', s: headerStyle }]
			];

			for (let i = 0; i < response.length; i++) {
				const excelItems = [];
				excelItems.push({ v: i + 1, s: cellStyle }); // Add row number
				excelItems.push({ v: response[i].name, s: wrapTextStyle });
				excelItems.push({ v: response[i].phone1, s: cellStyle });
				excelItems.push({ v: response[i].phone2, s: cellStyle });
				excelItems.push({ v: response[i].note !== null ? response[i].note : "", s: wrapTextStyle }); // Check for null note

				let usdValue = 0;
				let sumValue = 0;

				for (let j = 0; j < response[i]['balanceList'].length; j++) {
					if (response[i]['balanceList'][j]['currencyName'] === "USD") {
						usdValue = response[i]['balanceList'][j]['totalAmount'] || 0;
					}
					if (response[i]['balanceList'][j]['currencyName'] === t('SUM')) {
						sumValue = response[i]['balanceList'][j]['totalAmount'] || 0;
					}
				}

				excelItems.push({ v: usdValue, s: cellStyle });
				excelItems.push({ v: sumValue, s: cellStyle });

				excelHeaders.push(excelItems);
			}

			const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
			styleExcelSheet(ws)
			ws['!cols'] = columnWidths; // Set column widths
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
			XLSX.writeFile(wb, t('CLIENTS') + ".xlsx");
		} else {
			const { tableSortKey: _sk2, tableSortDirection: _sd2, ...filterDataForSearch } = filterData
			const urlWithSort = WithoutParams + (sortParam ? (WithoutParams.includes('?') ? '&' : '?') + sortParam : '')
			const response = await PGET(urlWithSort, { ...filterDataForSearch, size: ItemsPerPage }, { loader: true })
			if (response) {
				setData(response.data)
				setPagination({ ...pagination, 'url': filterUrl, 'response': response })
				setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))

			}
			filterUrl = "/services/web/api/report-client-total" + filterUrlParams
			const temporaryTotalAmount = await GET(filterUrl)
			setTotalAmont(temporaryTotalAmount)

			setDropdownIsOpen(false)
		}
	}

	function resetFilter() {
		setFilterData({
			startDate: null,
			endDate: null,
			posId: null,
			paymentPurposeId: null,
			productCategoryId: null,
			groupBy: false,
			search: '',
			tableSortKey: '',
			tableSortDirection: ',asc',
		})
		setFilterDataExist(false)
		getData()
	}

	function checkFilter() {
		if (
			filterData.startDate === null &&
			filterData.endDate === null &&
			filterData.posId === null &&
			filterData.paymentPurposeId === null &&
			filterData.groupBy === false &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	async function paginate(data) {
		const { tableSortKey: _sk3, tableSortDirection: _sd3, ...filterDataForPage } = filterData
		const response = await PGET(URL, { ...filterDataForPage, page: data.selected, size: ItemsPerPage }, { loader: true })
		setFilterData({ ...filterData, page: data.selected })
		setPageCount(Math.ceil(response.headers['x-total-count'] / ItemsPerPage))
		setData(response.data);
	}


	useEffect(() => {
		getData()
		getPoses()
	}, [ItemsPerPage]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter(false)
	}, [filterData.search, ItemsPerPage]) // eslint-disable-line react-hooks/exhaustive-deps

	function selectedItemEdit(index) {
		var dataCopy = [...data]
		for (let i = 0; i < dataCopy.length; i++) {
			dataCopy[index].showInput = true
			if (!dataCopy[i].showInput) {
				dataCopy[i].showInput = false
			}
		}
	}

	function cancelSelectedItemEdit(index) {
		var dataCopy = [...data]
		// dataCopy[index] = { ...dataDuplicate }
		dataCopy[index]['debitExpDate'] = ''
		for (let i = 0; i < dataCopy.length; i++) {
			dataCopy[i].visible = true
			dataCopy[i].showInput = false
		}
		setData(dataCopy)
	}

	const confirmModalShow = async (index) => {
		var dataCopy = [...data];
		console.log(dataCopy);

		try {
			const response = await POST('/services/web/api/update-client-debit-exp-date', {
				id: dataCopy[index]?.clientId,
				date: dataCopy[index]?.debitExpDate
			}, { loader: true });

			if (response) {
				toast.success(t('SUCCESS'));
				await getData(); // Ensure data is fetched only after the POST request succeeds
			} else {
				toast.error(t('ERROR'));
			}
		} catch (error) {
			toast.error(t('ERROR'));
			console.error(error);
		}
	};


	function handleExpDateChange(date, index) {
		var dataCopy = [...data]
		dataCopy[index]['debitExpDate'] = formatDateBackend(date)
		setData(dataCopy)
	}
	return (
		<>
			<div className="page-header d-flex justify-content-between mb-2">
				<h4 className="vertical-center">
					{t('CLIENTS')}
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
							<div>
								<button className="btn btn-outline-primary btn-wide me-2" onClick={() => showPaymentModal(true)}>
									{t('PAY')}
								</button>
							</div>
							<div>
								<button className="btn btn-outline-danger btn-wide me-2" onClick={() => showPaymentModal(true, true)}>
									{t('ADD_DEBT')}
								</button>
							</div>
							<div>
								<button className="btn btn-outline-info btn-wide me-2" onClick={sendDebtSms}>
									{t('SEND_MESSAGE')}
								</button>
							</div>
							<div>
								<button className="btn btn-outline-primary btn-wide me-2" onClick={() => searchWithFilter(true)}>
									EXCEL
								</button>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100 me-2">
										{t('FILTER')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('POS')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.posId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'posId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('EXPENSE_TYPE')}</label>
												<Select
													options={paymentPurposes}
													value={paymentPurposes.find(option => option.id === filterData.paymentPurposeId) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'paymentPurposeId': option.id })}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('PERIOD')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.startDate ? new Date(filterData.startDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'startDate': formatDateBackend(date) })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-6">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.endDate ? new Date(filterData.endDate) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'endDate': formatDateBackend(date) })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('CANCEL')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter()}>{t('APPLY')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
						<div className="d-flex">
							<div className="vertical-center me-2">
								<h4>
									<b>{t('TOTAL_AMOUNT')}</b>:
								</h4>
							</div>
							<div className="vertical-center">
								{totalAmount?.map((item, index) => (
									<h5 className="text-end" key={index}>
										<span className="me-1">{formatMoney(item.totalAmount)}</span>
										<b>{item.currencyName}</b>
									</h5>
								))
								}
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('FILTER')}</strong>
								<br />
								{(filterData.startDate || filterData.endDate) &&
									<span className="me-2">
										<b>{t('PERIOD')}: </b>
										{filterData.startDate &&
											<span>{formatDate(filterData.startDate)}</span>
										}
										{(filterData.startDate && filterData.endDate) &&
											<span>|</span>
										}
										{filterData.endDate &&
											<span>{formatDate(filterData.endDate)}</span>
										}
									</span>
								}
								{filterData.posId ?
									<span className="me-2">
										<b>{t('POS')}: </b> {findFromArrayById(poses, filterData.posId)}
									</span>
									:
									''
								}
								{filterData.paymentPurposeId &&
									<span className="me-2">
										<b>{t('EXPENSE_TYPE')}: </b> {findFromArrayById(paymentPurposes, filterData.paymentPurposeId)}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('SEARCH')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('RESET')}</button>
							</div>
						</div>
					}

					<ItemPerPage
						itemsPerPage={ItemsPerPage}
						setItemsPerPage={(e) => {
							setItemsPerPage(e); // Update ItemsPerPage
							setFilterData({ ...filterData, page: 0, random: filterData.random + 1 }); // Reset to the first page

						}}
					/>


					<div className="table-responsive">
						<table className="table table-hover cursor mb-0">
							<thead>
								<tr>
									<th className="cursor-pointer" onClick={() => searchWithFilter(false, 'name')}>
										{t('CLIENT')}
										{filterData.tableSortKey === 'name' ? (filterData.tableSortDirection === ',asc' ? ' ↑' : ' ↓') : ''}
									</th>
									<th>{t("MOBILE")}</th>
									<th>{t("PHONE")}</th>
									<th>{t("NOTE")}</th>
									<th className="text-center" colSpan={2}>{t("EXPIRATION_DATE")}</th>
									<th className="text-center cursor-pointer" onClick={() => searchWithFilter(false, 'totalBalance')}>
										{t("CUSTOMER_DEBT")}
										{filterData.tableSortKey === 'totalBalance' ? (filterData.tableSortDirection === ',asc' ? ' ↑' : ' ↓') : ''}
									</th>
									<th className="text-center">{t("ACTION")}</th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr className={'tr-middle ' + (
										(selectedItem && selectedItem.clientId === item.clientId) ? 'table-tr-active' : '')}
										key={index} onClick={() => selectItem(item)}>
										<td>
											<span className="text-primary cursor table-first-column-clickable"
												onClick={() => redirectToInner(item)}>
												{item.rowNum}. {item.name}
											</span>
										</td>
										<td>{regexPhoneNumber(item.phone1)}</td>
										<td>{regexPhoneNumber(item.phone2)}</td>
										<td>{item.note}</td>
										{/* <td>{item.debitExpDate}</td> */}
										<td className="text-center">
											{!item.showInput ?
												<span>{formatDate(item.debitExpDate)}</span>
												:
												<DatePicker
													className="auto-width-input"
													selected={item.debitExpDate ? new Date(item.debitExpDate) : ''}
													dateFormat="dd.MM.yyyy"
													onChange={(date) => handleExpDateChange(date, index)} />
											}
										</td>
										<td className="d-flex justify-content-center">
											{!item.showInput &&
												<div className="table-action-button table-action-primary-button" onClick={() => selectedItemEdit(index)}>
													<i className="uil-edit-alt"></i>
												</div>
											}
											{item.showInput &&
												<>
													<div className="table-action-button table-action-primary-button me-2" onClick={() => confirmModalShow(index)}>
														<i className="uil-check"></i>
													</div>
													<div className="table-action-button table-action-danger-button" onClick={() => cancelSelectedItemEdit(index)}>
														<i className="uil-times"></i>
													</div>
												</>
											}
										</td>
										<td className="text-center">
											{item?.balanceList?.map((item, index) => (
												<div className={item.totalAmount > 0 ? 'text-success' : 'text-danger'} key={index}>
													<span className="me-1">{formatMoney(item.totalAmount)}</span>
													<b>{item.currencyName}</b>
												</div>
											))
											}
										</td>
										<td>
											<div className="d-flex justify-content-center">
												<div className="table-action-button table-action-primary-button me-2"
													title={t('DEBTOR')}
													onClick={() => redirectToInner(item)}>
													<i className="uil-credit-card-search"></i>
												</div>
												<div className="table-action-button table-action-primary-button"
													title={t('CHEQUES')}
													onClick={() => redirectToSelectOnSale(item)}>
													<i className="uil-receipt"></i>
												</div>
											</div>
										</td>

									</tr>
								))
								}
							</tbody>
						</table>
					</div>

					<Pagination pageCount={pageCount} paginate={paginate} reduxPage={filterData.page}></Pagination>

				</div>
			</div>

			{/* MODAL PAYMENT */}
			<Modal show={modalPayment} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={() => showPaymentModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{isDebt ? t('ADD_DEBT') : t('PAY')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={payment} autoComplete="off">
						<div className="form-group">
							<label>{t('POS')}</label>
							<Select
								options={poses}
								value={poses.find(option => option.id === selectedItem.posId)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'posId': option.id })}
								placeholder=""
								noOptionsMessage={() => t('LIST_IS_EMPTY')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('PAYMENT_METHOD')}</label>
							<Select
								options={paymentTypes}
								value={paymentTypes.find(option => option.id === selectedItem.paymentTypeId)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'paymentTypeId': option.id })}
								placeholder=""
								noOptionsMessage={() => t('LIST_IS_EMPTY')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('CHOOSE_PAYMENT_TYPE')}</label>
							<Select
								options={currencies}
								value={currencies.find(option => option.id === selectedItem.currencyId)}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'currencyId': option.id })}
								placeholder=""
								noOptionsMessage={() => t('LIST_IS_EMPTY')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>
						<div className="form-group">
							<label>{t('AMOUNT')}<span className="required-mark">*</span></label>
							<input type="number" className="form-control" name="amountIn" autoFocus step="any" value={selectedItem.amountIn}
								onChange={(e) => {
									const inputValue = e.target.value;

									// Allow the value to be negative or positive
									setSelectedItem({
										...selectedItem,
										amountIn: inputValue
									});
								}} />
						</div>
						<div className="form-group">
							<label>{t('NOTE')}</label>
							<input type="text" className="form-control" name="note"
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>
						<div className="d-flex w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100 me-2"
								onClick={() => showPaymentModal(false)} tabIndex="-1">{t('CANCEL')}</button>
							<button type="submit" className="btn btn-primary w-100" disabled={!selectedItem.amountIn}>
								{t('SAVE')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT */}
		</>
	)
}

export default Index
